module.exports = __webpack_public_path__ + "static/producrImgDemo-718624a8ee39ead9cd99f553746748b1.mp4";